import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=284e06e8&scoped=true"
import script from "./videoPlay.vue?vue&type=script&lang=js"
export * from "./videoPlay.vue?vue&type=script&lang=js"
import style0 from "./videoPlay.vue?vue&type=style&index=0&id=284e06e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e06e8",
  null
  
)

export default component.exports